import React from "react";
import MasonrySection from "../components/MasonrySection";
import { useState, useMemo } from "react";

const familyImages = [
  "/images/Family/Family1.jpg",
  "/images/Family/Family2.jpg",
  "/images/Family/Family3.jpg",
  "/images/Family/Family4.jpg",
  "/images/Family/Family5.jpg",
  "/images/Family/Family6.jpg",
  "/images/Family/Family7.jpg",
  "/images/Family/Family8.jpeg",
  "/images/Family/Family9.jpeg",
  "/images/Family/Family10.jpeg",
  "/images/Family/Family11.jpeg",
  "/images/Family/Family12.jpeg",
  "/images/Family/Family13.jpeg",
  "/images/Family/Family14.jpg",
  "/images/Family/Family15.jpg",
  "/images/Family/Family16.jpg",
  "/images/Family/Family17.jpg",
  "/images/Family/Family18.jpg",
  "/images/Family/Family19.jpg",
  "/images/Family/Family20.jpg",
  "/images/Family/Family21.jpg",
  "/images/Family/Family22.jpg",
  "/images/Family/Family23.jpg",
  "/images/Family/Family24.jpg",
  "/images/Family/Family25.jpg",
  "/images/Family/Family26.jpg",
  "/images/Family/Family27.jpg",
  "/images/Family/Family28.jpg",
  "/images/Family/Family29.jpg",
  "/images/Family/Family30.jpg",
  "/images/Family/Family31.jpg",
  "/images/Family/Family32.jpg",
  "/images/Family/Family33.JPG",
  "/images/Family/Family34.jpeg",
  "/images/Family/Family36.JPG",
  "/images/Family/Family37.jpeg",
  "/images/Family/Family38.jpeg",
  "/images/Family/Family39.jpeg",
  "/images/Family/Family40.jpeg",
  "/images/Family/Family41.JPG",
  "/images/Family/Family42.jpg",
  "/images/Family/Family43.jpeg",
  "/images/Family/Family44.jpeg",
];

const activityImages = [
  "/images/Activities/Act1.jpeg",
  "/images/Activities/Act2.jpeg",
  "/images/Activities/Act3.jpeg",
  "/images/Activities/Act4.JPG",
  "/images/Activities/Act5.JPG",
  "/images/Activities/Act6.JPG",
  "/images/Activities/Act7.JPG",
  "/images/Activities/Act8.JPG",
  "/images/Activities/Act9.JPG",
  "/images/Activities/Act10.JPG",
  "/images/Activities/Act11.jpeg",
  "/images/Activities/Act12.jpeg",
  "/images/Activities/Act13.jpeg",
  "/images/Activities/Act14.jpeg",
  "/images/Activities/Act15.jpeg",
  "/images/Activities/Act16.jpeg",
  "/images/Activities/Act17.jpeg",
  "/images/Activities/Act18.jpeg",
  "/images/Activities/Act19.jpeg",
  "/images/Activities/Act20.jpeg",
  "/images/Activities/Act22.jpeg",
  "/images/Activities/Act23.jpeg",
  "/images/Activities/Act24.jpeg",
  "/images/Activities/Act25.jpeg",
  "/images/Activities/Act26.jpeg",
];

const travelImages = [
  "/images/Travel/Travel1.jpg",
  "/images/Travel/Travel2.jpg",
  "/images/Travel/Travel3.jpg",
  "/images/Travel/Travel4.JPG",
  "/images/Travel/Travel5.JPG",
  "/images/Travel/Travel6.JPG",
  "/images/Travel/Travel7.JPG",
  "/images/Travel/Travel8.JPG",
  "/images/Travel/Travel9.JPG",
  "/images/Travel/Travel10.JPG",
  "/images/Travel/Travel11.JPG",
  "/images/Travel/Travel12.jpg",
  "/images/Travel/Travel13.JPG",
  "/images/Travel/Travel14.jpeg",
  "/images/Travel/Travel15.JPG",
  "/images/Travel/Travel16.jpeg",
  "/images/Travel/Travel17.jpeg",
  "/images/Travel/Travel18.JPG",
  "/images/Travel/Travel19.JPG",
  "/images/Travel/Travel20.JPG",
  "/images/Travel/Travel21.JPG",
  "/images/Travel/Travel22.JPG",
  "/images/Travel/Travel23.jpeg",
  "/images/Travel/Travel24.JPG",
  "/images/Travel/Travel25.JPG", 
  "/images/Travel/Travel26.JPG",
];

function SectionGallery({ title, subtitle, images, initialCount = 6, step = 6 }) {
  const [visibleCount, setVisibleCount] = useState(initialCount);

  const visibleImages = useMemo(
    () => images.slice(0, visibleCount),
    [images, visibleCount]
  );

  const canLoadMore = visibleCount < images.length;

  return (
    <section className="space-y-4">
      <div>
        <h2 className="text-3xl font-bold text-yellow-700">{title}</h2>
        {subtitle && <p className="text-gray-700 mt-1">{subtitle}</p>}
      </div>

      {/* Grid (swap to your masonry if you want) */}
      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6">
        {visibleImages.map((src, idx) => (
          <div key={`${src}-${idx}`} className="rounded-2xl overflow-hidden shadow-lg bg-white">
            <img
              src={src}
              alt={`${title} ${idx + 1}`}
              loading="lazy"
              className="w-full h-56 object-cover hover:scale-[1.02] transition-transform duration-300"
            />
          </div>
        ))}
      </div>

      {/* Load more */}
      <div className="flex justify-center pt-2">
        {canLoadMore ? (
          <button
            onClick={() => setVisibleCount((prev) => Math.min(prev + step, images.length))}
            className="px-6 py-3 rounded-xl bg-yellow-600 text-white font-semibold shadow hover:bg-yellow-700 transition"
          >
            Load more
          </button>
        ) : (
          <p className="text-gray-500 text-sm">That’s everything for this section 💛</p>
        )}
      </div>
    </section>
  );
}

export default function Gallery() {
  return (
    <div className="pt-24 px-6 max-w-6xl mx-auto space-y-16">
      <SectionGallery
        title="Family & Friends"
        subtitle="Precious moments with family & friends 🧡"
        images={familyImages}
        initialCount={9}
        step={9}
      />

      <SectionGallery
        title="Activities"
        subtitle="Fun moments and hobbies 🎉"
        images={activityImages}
        initialCount={9}
        step={9}
      />

      <SectionGallery
        title="Travel"
        subtitle="Adventures and trips 🌎"
        images={travelImages}
        initialCount={9}
        step={9}
      />
    </div>
  );
}